import script from "./AdminAuthentication.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminAuthentication.vue?vue&type=script&setup=true&lang=js"

import "./AdminAuthentication.vue?vue&type=style&index=0&id=502a1334&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-502a1334"]])

export default __exports__